<template>
  <div v-if="dataPermission?.includes('CNPS_AGENCY_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý đại lý</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="dataPermission?.includes('CNPS_AGENCY_CREATE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="$router.push('/list-agency-add')"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keyword"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.keeperId"
              :options="dataManagers"
              placeholder="Người phụ trách"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCode"
              :options="dataRegions"
              placeholder="Vùng phụ trách"
            ></Select2>
          </div>

          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng đại lý {{ pagination.total }}
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="dataTable"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <p v-if="data.item.createdDate">
                  <span class="text-secondary">Tạo:</span>
                  {{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.lastModifiedDate">
                  Cập nhât:
                  {{ data.item.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(keeperName)="data">
                <p>
                  {{ data.item?.keeperName }}
                </p>
                <a :href="`mailto:${data.item?.keeperEmail}`">
                  {{ data.item?.keeperEmail }}
                </a>
              </template>

              <template #cell(name)="data">
                <p style="font-weight: bold">
                  {{ data.item.name }}
                </p>
                <p class="text-secondary">
                  {{ data.item?.address }}
                </p>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button
                    class="dropdown-item"
                    @click="detailItem(data.item.id)"
                    v-if="dataPermission?.includes('CNPS_AGENCY_DETAIL')"
                  >
                    <i class="bx bx-detail"></i><span>&nbsp;</span>Chi tiết
                  </button>
                  <button
                    v-if="dataPermission?.includes('CNPS_AGENCY_UPDATE')"
                    class="dropdown-item"
                    @click="update(data.item.id)"
                  >
                    <i class="bx bx-copy"></i><span>&nbsp;</span>Cập nhật
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>

        <div class="pagination-bottom d-flex justify-content-end align-items-center">
          <!-- AI: Thêm phần lựa chọn số lượng items trên mỗi trang -->

          <div class="pagination-size">
            <!-- AI: Phần lựa chọn số lượng items mỗi trang -->

            <select
              class="form-control d-inline-block mr-3"
              style="width: 100px; margin-top: 20px"
              v-model="search.limit"
              @change="onChangeLimit($event.target.value)"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>

          <!-- AI: Nút điều hướng phân trang -->
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            @change="onChangePage"
            class="mb-0"
            first-number
            last-number
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { getListAgency } from '@/services/agencty'
  import { StaffService } from '@/services/staff.service'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'name', label: 'Đại lý' },
    { key: 'time', label: 'Thời gian' },
    { key: 'keeperName', label: 'Người phụ trách' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        dataTable: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        // dateRange: {
        //   startDate: null,
        //   endDate: null
        // },
        dataManagers: [],
        dataRegions: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
      }
    },

    created() {
      this.fetchData()
      this.loadSelectData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async loadSelectData() {
        try {
          const userRes = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (userRes.code === 1000) {
            this.dataManagers = userRes.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
              }
            })
            this.dataManagers.unshift({ id: '0', text: 'Tất cả' })
          }
          const reigonRes = await StaffService.getRegions()
          if (reigonRes.code === 1000) {
            this.dataRegions = reigonRes.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataRegions.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      detailItem(id) {
        this.$router.push({
          name: 'manageAgencyDetail',
          params: { id: id },
        })
      },
      update(id) {
        this.$router.push({
          name: 'manageAgencyEdit',
          params: { id: id },
        })
      },
      onChangeLimit(value) {
        // AI: Xử lý khi thay đổi số lượng items mỗi trang

        this.search.limit = value // AI: Cập nhật số lượng item mỗi trang

        this.search.page = 1 // AI: Reset về trang đầu tiên

        this.fetchData() // AI: Gọi lại API để lấy dữ liệu
      },

      onChangePage(page) {
        // AI: Xử lý khi chuyển trang

        this.search.page = page // AI: Cập nhật trang hiện tại

        this.fetchData() // AI: Gọi lại API để lấy dữ liệu
      },

      showModalCancelMoving(item) {
        this.cancelMovingCancel = true
        this.itemCancelMoving = item
      },

      getIndex(index) {
        // AI: Tính toán chỉ số bắt đầu của items dựa vào trang hiện tại

        return (this.search.page - 1) * this.search.limit + index + 1 // AI: Công thức: (trang hiện tại - 1) * số lượng mỗi trang + chỉ số hàng
      },

      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          if (this.search.keeperId === '0') delete this.search.keeperId
          if (this.search.regionCode === '0') delete this.search.regionCode
          const query = {
            ...this.search,
            limit: this.search.limit,
            page: this.search.page,
            sortResultList: [
              {
                field: 'createdDate',
                direction: 'DESC',
              },
            ],
          }
          const response = await getListAgency(query)
          if (response.code === 1000) {
            this.dataTable = response.data || []
            this.pagination.total = response.paging.total || 0
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
